import { ChapterListResponseChapterGenerationStatusEnum, ChapterResponse } from '@goldcast/api/content';
import { Speaker } from '@/domains/speaker';
import { Word, WordType } from '@/domains/transcript';

export interface SpeakerWithDetails extends Omit<Speaker, 'face_ids'> {
  id: string;
  key: string;
  color: string;
  bgColor: string;
  lightBgColor: string;
  hoverBgColor: string;
  speakingSlots: Record<string, number>;
  parent_id: string | null;
  face_ids?: number[];
}

export enum ChapterGenerationStatus {
  DONE = 'DONE',
  FAILED = 'FAILED',
  NOT_STARTED = 'NOT_STARTED',
  PROCESSING = 'PROCESSING'
}

export interface TranscriptContextData {
  transcript: Word[];
  end: number;
  speakersWithDetails: Record<string, SpeakerWithDetails>;
  usedSpeakers: SpeakerWithDetails[];
  chapterData: ChapterResponse[] | undefined;
  chapterGenerationStatus: ChapterListResponseChapterGenerationStatusEnum;
  chaptersLastUpdatedAt: string | null;
  timeSrtIndexArray: {
    startTime: number;
    srtIndex: number;
  }[];
  isTranscriptInitialized: boolean;
}

export interface RawWord {
  start_time: number;
  end_time: number;
  type: WordType;
  speaker_label: string;
  srt_index: number;
  alternatives: { content: string }[];
}
